var _path, _path2, _mask, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5098 11.0209V6.12445C10.5096 5.25526 10.1657 4.42061 9.54492 3.81L9.54199 3.80707L7.2998 1.57269C7.21444 1.48772 7.08319 1.47768 6.98633 1.54144L6.94727 1.57269L4.69531 3.81683C4.07813 4.43181 3.72669 5.26919 3.72656 6.13422V11.0307C3.72634 11.4447 3.39064 11.7807 2.97656 11.7807C2.56249 11.7807 2.22679 11.4447 2.22656 11.0307V6.13422C2.22669 4.86524 2.74007 3.64695 3.63574 2.75433L5.8877 0.510193L6.02051 0.391052C6.70702 -0.167418 7.71805 -0.127725 8.3584 0.510193L10.5967 2.74066L10.7637 2.91254C11.5701 3.79048 12.0097 4.93854 12.0098 6.12445V11.0209C12.0095 11.4349 11.6738 11.7709 11.2598 11.7709C10.8459 11.7707 10.51 11.4348 10.5098 11.0209Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4951 10.75L13.5713 10.7539C13.9496 10.7922 14.2451 11.1116 14.2451 11.5C14.2451 11.8884 13.9496 12.2078 13.5713 12.2461L13.4951 12.25H0.75C0.335786 12.25 0 11.9142 0 11.5C0 11.0858 0.335786 10.75 0.75 10.75H13.4951Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_7526_3227",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.29688 13.1162C5.29688 14.1247 6.12229 14.9472 7.13441 14.9472C8.14653 14.9472 8.97195 14.1247 8.97195 13.1162"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29688 13.1162C5.29688 14.1247 6.12229 14.9472 7.13441 14.9472C8.14653 14.9472 8.97195 14.1247 8.97195 13.1162",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29688 13.1162C6.29688 12.5639 5.84916 12.1162 5.29688 12.1162C4.74459 12.1162 4.29688 12.5639 4.29688 13.1162H6.29688ZM9.97195 13.1162C9.97195 12.5639 9.52423 12.1162 8.97195 12.1162C8.41966 12.1162 7.97195 12.5639 7.97195 13.1162H9.97195ZM5.29688 13.1162H4.29688C4.29688 14.6804 5.5734 15.9472 7.13441 15.9472V14.9472V13.9472C6.67119 13.9472 6.29688 13.569 6.29688 13.1162H5.29688ZM7.13441 14.9472V15.9472C8.69543 15.9472 9.97195 14.6804 9.97195 13.1162H8.97195H7.97195C7.97195 13.569 7.59764 13.9472 7.13441 13.9472V14.9472Z",
    fill: "white",
    mask: "url(#path-3-inside-1_7526_3227)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/Messages.0ef5b008113513dd313b83b93fa59b7b.svg";
export { ForwardRef as ReactComponent };